const DEFAULT_MAX_DIMENSION = 1600;
const DEFAULT_QUALITY = 0.85;
const JPEG = 'image/jpeg';
const PNG = 'image/png';

const EXTENSIONS = { [PNG]: 'png', [JPEG]: 'jpg' };

const failureFor = file => new Error(`Não foi possível processar a imagem ${file.name}`);

const loadImage = file =>
  new Promise((resolve, reject) => {
    const source = URL.createObjectURL(file);
    const image = new Image();
    const settle = handler => () => {
      URL.revokeObjectURL(source);
      handler();
    };

    image.onload = settle(() => resolve(image));
    image.onerror = settle(() => reject(failureFor(file)));
    image.src = source;
  });

const toBlob = (canvas, type, quality) =>
  new Promise(resolve => canvas.toBlob(resolve, type, quality));

const normalizeImage = async (file, options = {}) => {
  const {
    maxWidth = DEFAULT_MAX_DIMENSION,
    maxHeight = maxWidth,
    type,
    quality = DEFAULT_QUALITY,
  } = options;

  const outputType = type || (file.type === PNG ? PNG : JPEG);
  const image = await loadImage(file);
  const scale = Math.min(1, maxWidth / image.width, maxHeight / image.height);

  if (scale === 1 && file.type === outputType) return file;

  const width = Math.max(1, Math.round(image.width * scale));
  const height = Math.max(1, Math.round(image.height * scale));
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const context = canvas.getContext('2d');

  if (!context) throw failureFor(file);

  if (outputType !== PNG) {
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, width, height);
  }

  context.imageSmoothingEnabled = true;
  context.imageSmoothingQuality = 'high';
  context.drawImage(image, 0, 0, width, height);

  const blob = await toBlob(canvas, outputType, quality);

  if (!blob) throw failureFor(file);

  const name = file.name.replace(/\.[^.]+$/, '') || 'imagem';

  return new File([blob], `${name}.${EXTENSIONS[outputType] || 'jpg'}`, {
    type: outputType,
    lastModified: Date.now(),
  });
};

export default normalizeImage;
